import { selectCurrentEntities } from 'ducks/entities/selectors'
import { emptyArr } from 'util/arrays'

export const selectCurrentFacebookPages = state =>
  selectCurrentEntities(state, 'facebookPage') || emptyArr
